export const getParentCategoryFromSubCategory = (
    subcategory: string,
): string => {
    const subcategoryId = subcategory.split('/')[1];
    const shouldGrabOneDigit = subcategoryId.length === 4;
    const categoryId = shouldGrabOneDigit
        ? `10${subcategoryId.slice(0, 1)}`
        : `1${subcategoryId.slice(0, 2)}`;

    const categoryKey = `EventbriteCategory/${categoryId}`;
    return categoryKey;
};
